export const ORDER_TYPE_DROPSHIP = 'dropship';
export const ORDER_TYPE_ECOMMERCE = 'ecommerce';
export const ORDER_TYPE_MARKETPLACE = 'marketplace';
export const ORDER_TYPE_REORDER = 'reorder';
export const ORDER_TYPE_REPLENISH = 'replenish';

export const OrderTypesDisplayName = {
  [ORDER_TYPE_DROPSHIP]: 'Drop Ship',
  [ORDER_TYPE_ECOMMERCE]: 'eComm',
};

export const OrderTypesAllTypes = {
  [ORDER_TYPE_DROPSHIP]: [ORDER_TYPE_DROPSHIP, ORDER_TYPE_ECOMMERCE, ORDER_TYPE_MARKETPLACE],
  [ORDER_TYPE_REORDER]: [ORDER_TYPE_REORDER, ORDER_TYPE_REPLENISH],
};
